import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { doRequest } from '../../utils/helper';

const initialState = {
  designs: [],
  pagination: {},
  currentDesign: null,
  designInfo: null,
  isLoading: false,
  error: null,
  success: false,
  message: '',
  createdDesignId: null
};

// Create Design
export const createDesign = createAsyncThunk(
  'design/createDesign',
  async ({ designData, navigate = null, newTab = false }, { rejectWithValue }) => {
    try {

      const { redirect_to, ...rest } = designData;

      const data = await doRequest(rest, 'POST', 'design/create');
      if (data?.resultFlag === 1) {
        // if(navigate !== null){
        //   navigate(`/variation/${data.response.id}`);
        // }
        // else{
        //   window.location.href = `/variation/${data.response.id}`;
        // }

        if (redirect_to === "variation_page") {
          if (navigate !== null) {
            navigate(`/variation/${data.response.id}`);
          }
          else {
            window.location.href = `/variation/${data.response.id}`;
          }
        }
        else if (redirect_to === "export_page") {
          if (navigate !== null) {
            navigate(`/export/${data.response.id}`);
          }
          else {
            window.location.href = `/export/${data.response.id}`;
          }
        }

        else if (redirect_to === "design_page") {
          if (navigate !== null) {
            if (newTab) {
              window.open(
                `/design/${data.response.id}`,
                "_blank"
              );
            } else {
              navigate(`/design/${data.response.id}`);
            }
          }
          else {
            window.location.href = `/design/${data.response.id}`;
          }
        }


        return data;
      } else {
        return rejectWithValue(data?.message || 'Failed to create design');
      }
    } catch (error) {
      return rejectWithValue('Failed to create design. Please try again.');
    }
  }
);

// Update Design
export const updateDesign = createAsyncThunk(
  'design/updateDesign',
  async ({ id, designData, navigate = null }, { rejectWithValue }) => {
    try {

      console.log("before update design, ", designData, " and id is", id);
      const { redirect_to, ...rest } = designData;

      console.log("id is", id);
      console.log("designData is", designData);

      const data = await doRequest(rest, 'POST', `design/update/${id}`);
      if (data?.resultFlag === 1) {
        if (redirect_to === "variation_page") {
          if (navigate !== null) {
            navigate(`/variation/${id}`);
          }
          else {
            window.location.href = `/variation/${id}`;
          }
        }
        else if (redirect_to === "export_page") {
          if (navigate !== null) {
            navigate(`/export/${id}`);
          }
          else {
            window.location.href = `/export/${id}`;
          }
        }
        return data;
      } else {
        return rejectWithValue(data?.message || 'Failed to update design');
      }
    } catch (error) {
      return rejectWithValue('Failed to update design. Please try again.');
    }
  }
);

// Delete Design
export const deleteDesign = createAsyncThunk(
  'design/deleteDesign',
  async (id, { rejectWithValue }) => {
    try {
      const data = await doRequest(null, 'POST', `design/delete/${id}`);
      if (data?.resultFlag === 1) {
        return { id, message: data.message };
      } else {
        return rejectWithValue(data?.message || 'Failed to delete design');
      }
    } catch (error) {
      return rejectWithValue('Failed to delete design. Please try again.');
    }
  }
);

// Get Design Detail
export const getDesignDetail = createAsyncThunk(
  'design/getDesignDetail',
  async (id, { rejectWithValue }) => {
    try {
      const data = await doRequest(null, 'GET', `design/detail/${id}`);
      if (data?.resultFlag === 1) {
        return data.response;
      } else {
        return rejectWithValue(data?.message || 'Failed to fetch design detail');
      }
    } catch (error) {
      return rejectWithValue('Failed to fetch design detail. Please try again.');
    }
  }
);

// Get Designs List
export const getDesignsList = createAsyncThunk(
  'design/getDesignsList',
  async (params = {}, { rejectWithValue }) => {
    try {
      const queryString = new URLSearchParams(params).toString();
      const url = queryString ? `design/list?${queryString}` : 'design/list';
      const data = await doRequest(null, 'GET', url);
      if (data?.resultFlag === 1) {
        return data.response;
      } else {
        return rejectWithValue(data?.message || 'Failed to fetch designs');
      }
    } catch (error) {
      return rejectWithValue('Failed to fetch designs. Please try again.');
    }
  }
);

const designSlice = createSlice({
  name: 'design',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
      state.message = '';
    },
    clearSuccess: (state) => {
      state.success = false;
      state.message = '';
    },
    clearCurrentDesign: (state) => {
      state.currentDesign = null;
    },
    resetDesignState: (state) => {
      state.designs = [];
      state.currentDesign = null;
      state.isLoading = false;
      state.error = null;
      state.success = false;
      state.message = '';
    },
    setIsLoading: (state, action) => {
      state.isLoading = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      // Create Design
      .addCase(createDesign.pending, (state) => {
        state.isLoading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(createDesign.fulfilled, (state, action) => {
        state.isLoading = false;
        state.success = true;
        state.message = action.payload.message;
        state.currentDesign = action.payload.response;
        state.createdDesignId = action.payload.response.id;
        console.log("createdDesignId is", state.createdDesignId);
        // Add to designs list if it exists
        if (action.payload.response) {
          state.designs.unshift(action.payload.response);
        }
      })
      .addCase(createDesign.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
        state.success = false;
      })

      // Update Design
      .addCase(updateDesign.pending, (state) => {
        state.isLoading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(updateDesign.fulfilled, (state, action) => {
        state.isLoading = false;
        state.success = true;
        state.message = action.payload.message;
        state.currentDesign = action.payload.response;
        // Preserve the latest design id so subsequent saves update instead of creating duplicates
        state.createdDesignId = action.payload.response?.id ?? state.createdDesignId;
        console.log("createdDesignId is", state.createdDesignId);
        // Update in designs list
        if (action.payload.response) {
          const index = state.designs.findIndex(design => design.id === action.payload.response.id);
          if (index !== -1) {
            state.designs[index] = action.payload.response;
          }
        }
      })
      .addCase(updateDesign.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
        state.success = false;
      })

      // Delete Design
      .addCase(deleteDesign.pending, (state) => {
        state.isLoading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(deleteDesign.fulfilled, (state, action) => {
        state.isLoading = false;
        state.success = true;
        state.message = action.payload.message;
        // Remove from designs list
        state.designs = state.designs.filter(design => design.id !== action.payload.id);
        // Clear current design if it was the deleted one
        if (state.currentDesign && state.currentDesign.id === action.payload.id) {
          state.currentDesign = null;
        }
      })
      .addCase(deleteDesign.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
        state.success = false;
      })

      // Get Design Detail
      .addCase(getDesignDetail.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getDesignDetail.fulfilled, (state, action) => {
        state.isLoading = false;
        state.designInfo = action.payload;
        // state.currentDesign = action.payload;
      })
      .addCase(getDesignDetail.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })

      // Get Designs List
      .addCase(getDesignsList.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getDesignsList.fulfilled, (state, action) => {
        state.isLoading = false;
        state.designs = action.payload.data;
        state.pagination = action.payload.pagination;
      })
      .addCase(getDesignsList.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  }
});

export const {
  clearError,
  clearSuccess,
  clearCurrentDesign,
  resetDesignState,
  setIsLoading
} = designSlice.actions;

export default designSlice.reducer; 